/**
 * Article Table of Contents
 *
 * - Extracts all <h2> from [data-article-body]
 * - Injects slug IDs into each heading
 * - Renders the TOC list into [data-article-toc]
 * - Highlights active item via IntersectionObserver
 * - Smooth-scrolls on click
 */

document.addEventListener('DOMContentLoaded', () => {
  const tocEl = document.querySelector('[data-article-toc]');
  const bodyEl = document.querySelector('[data-article-body]');
  if (!tocEl || !bodyEl) return;

  const headings = Array.from(bodyEl.querySelectorAll('h2'));
  if (headings.length === 0) return;

  // Assign stable slug IDs to headings that don't already have one
  headings.forEach((h, i) => {
    if (!h.id) {
      const slug = h.textContent
        .trim()
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      h.id = slug || `toc-section-${i}`;
    }
  });

  // Build TOC HTML
  const items = headings
    .map(
      (h) =>
        `<li class="article-toc__item">
          <a href="#${h.id}" class="article-toc__link">${h.textContent.trim()}</a>
        </li>`
    )
    .join('');

  tocEl.innerHTML = `
    <div class="article-toc__inner">
      <p class="article-toc__title">CONTENTS</p>
      <hr class="article-toc__divider">
      <ul class="article-toc__list">${items}</ul>
    </div>
  `;

  const links = tocEl.querySelectorAll('.article-toc__link');

  // Set one link as active by its heading id
  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle('article-toc__link--active', link.getAttribute('href') === `#${id}`);
    });
  };

  // Default: highlight first heading
  setActive(headings[0].id);

  // Use IntersectionObserver to track which heading is in view
  const observer = new IntersectionObserver(
    (entries) => {
      // Pick the topmost intersecting entry
      const visible = entries.filter((e) => e.isIntersecting);
      if (visible.length === 0) return;
      // Sort by vertical position, take the highest one
      visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      setActive(visible[0].target.id);
    },
    {
      rootMargin: '-8% 0px -75% 0px',
      threshold: 0,
    }
  );

  headings.forEach((h) => observer.observe(h));

  // Smooth scroll on TOC link click
  tocEl.addEventListener('click', (e) => {
    const link = e.target.closest('.article-toc__link');
    if (!link) return;
    e.preventDefault();
    const targetId = link.getAttribute('href').slice(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Immediately reflect active state on click without waiting for observer
    setActive(targetId);
  });
});
